/**
 * The page header's two ways into a screen's guide (ADR 9044): «Guided tour» walks the screen
 * in place, «Read the guide» opens its five-part guide in Documentation. Drawn by the router for
 * a route whose chapter declares a guide for it, and for no other — a button that opened nothing
 * would teach the planner to ignore it.
 *
 * Quiet on purpose (`ghost`, small): the owner ruling of 2026-09-30 (ADR 9031) took the
 * explanatory line out from under every title, and these are a way to the explanation, not the
 * explanation brought back.
 */

import { BookOpen, Compass } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../primitives';

export interface GuideControlsProps {
  readonly onTour: () => void;
  readonly onRead: () => void;
}

export function GuideControls({ onTour, onRead }: GuideControlsProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div role="group" aria-label={t('guide.controls')} className="flex flex-wrap items-center gap-1" data-guide-controls="">
      <Button variant="ghost" size="sm" icon={<Compass size={14} aria-hidden />} onClick={onTour}>
        {t('guide.tour')}
      </Button>
      <Button variant="ghost" size="sm" icon={<BookOpen size={14} aria-hidden />} onClick={onRead}>
        {t('guide.read')}
      </Button>
    </div>
  );
}
